import { isEmpty } from "lodash";


function getQuotations(entities) {
    return Object.keys(entities.quotations).map(quotationId => {
        return {
            ...entities.quotations[quotationId],
            services: entities.quotations[quotationId].services.map(serviceId => entities.services[serviceId]),
        }
    })
}



export {
    getQuotations,
}